document.addEventListener('DOMContentLoaded', () => {
    
    const options = {
        valueNames: [ 
            'title',
            'excerpt',
            'initial_sort',
            'terms',
            'date'
        ],
        pagination: [{
            innerWindow: 2,
            outerWindow: 1,
        }],
        page: 12
    };
    
    // Create the list!
    const gridList = new List('searchSortGrid', options);

    const searchField = document.getElementById('custom-search');

    // Utility function to assist with fuzzy searching
    function includesSubstring(string, substring) {
        return string.toLowerCase().includes(substring.toLowerCase());

    }

    // Sort select element logic
    const sortSelect = document.getElementById('sort-select');
    if (sortSelect) {
        sortSelect.addEventListener('change', (e) => {
            const sortValue = e.target.value;

            if (sortValue === 'date') {
                gridList.sort('date', { order: "desc", sortFunction: (x, y) => {
                    return x._values.date - y._values.date;
                } });
                gridList.show(1,12);
            } else if (sortValue === 'alphabetical') {
                gridList.sort('title', { order: "asc" });
                gridList.show(1, 12);
            }
            
        });
    }

    let activeFilters = {
        search: "",
        filters: []
    };
    
    // Custom fuzzy search because the built in one has a character limit
    searchField.addEventListener('input', (e) => {

        activeFilters.search = e.target.value;

        do_filters();

    });

    const filters = document.querySelectorAll('.single-filter input');

    filters.forEach(e => {
        e.addEventListener('change', function(e){

            const checked = e.currentTarget.checked;
            const currentValue = e.currentTarget.id;
            
            // If a filter is checked and that filter is not in the activeFilters array, add it
            if (checked && !activeFilters.filters.includes(currentValue)) {
                activeFilters.filters.push(currentValue);
            }

            // Conversely, if a filter is unchecked and it is in the activeFilters array, we need to remove it
            if (!checked && activeFilters.filters.includes(currentValue)) {
                var filtered = activeFilters.filters.filter(function(value, index, arr){ 
                    return value != currentValue;
                });
                activeFilters.filters = filtered;
            }

            do_filters();

        });
    });

    function do_filters() {

        const search = activeFilters.search != "";
        const filters = activeFilters.filters.length != 0;

        // If no filters are set
        if ( ! search && ! filters ) {
            gridList.filter();
        } else {


            if ( search && ! filters ) {

                gridList.filter((item) => {
                    if ( 
                        includesSubstring(item._values.title, activeFilters.search) || 
                        includesSubstring(item._values.excerpt, activeFilters.search)
                    ) {
                        return true;
                    }
        
                    return false;
                });  

            } else if ( filters && ! search) {

                gridList.filter((item) => {

                    const termsArray = item.values().terms.split(', ').map((term) => {
                        return term.toLowerCase().split(' / ').join('-').split(' ').join('-');
                    });
    
                    if (activeFilters.filters.length === 0) {
                        return true;
                    }
        
                    if ( activeFilters.filters.filter(element => termsArray.includes(element)).length != 0 ) {
                        return true;
                    }
    
                    return false;
                });

            } else if ( filters && search ) {

                gridList.filter((item) => {

                    const termsArray = item.values().terms.split(', ').map(term => term.toLowerCase().split(' ').join('-'));
                    
                    const searchCondition = ( 
                        includesSubstring(item._values.title, activeFilters.search) || 
                        includesSubstring(item._values.excerpt, activeFilters.search) 
                    );

                    const filterCondition = ( activeFilters.filters.filter(element => termsArray.includes(element)).length != 0 );
    
                    if (searchCondition && filterCondition) {
                        return true;
                    }
                    
                    return false;

                });   
            }

        }
 
    }


    function displayPagination() {
        const pagination = document.querySelector('.pagination');
        if (gridList.matchingItems.length <= 12) {
            pagination.style.display = 'none';
        } else {
            pagination.style.display = 'flex';
        }
    }
    // Initial display or hide
    displayPagination();
    
    const emptyList = document.querySelectorAll('#searchSortGrid .none-found');
    gridList.on('updated',(e) => {

        // If there are no matching items, display the none found message
        if ( e.matchingItems.length === 0) {
            emptyList.item(0).style.display = 'block';
        } else {
            emptyList.item(0).style.display = 'none';
        }

        // Check pagination again
        displayPagination();

    })

    // Clear all button logic
    const clearAllButton = document.getElementById('clear-all-filters');
    if (clearAllButton) {
        clearAllButton.addEventListener('click', () => {
            // Clear list.js filters
            gridList.filter();
            
            // Uncheck all checkboxes
            filters.forEach(e => {
                e.checked = false;
            });

            // Reset activeFilters array
            activeFilters = {
                search: "",
                filters: []
            };

            // Reset list.js sort to our initial value
            gridList.sort('date', { order: "desc", sortFunction: (x, y) => {
                return x._values.date - y._values.date;
            } });

            // Clear the autocomplete input
            searchField.value = '';

        });
    }

    document.querySelector('.pagination').addEventListener('click', (e) => {
        // e.preventDefault();        
    });

    // Add event listeners to all the expand/collapse buttons
    gridList.items.forEach(item => {
        const content = item.elm.querySelector('.research-list__content');
        const arrow = item.elm.querySelector('.arrow');
        const toggleButton = item.elm.querySelector('.research-list__toggle');

        toggleButton.addEventListener('click', function() {
            // Toggle visibility of the content
            if (content.classList.contains('active')) {
                content.classList.remove('active');
            } else {
                content.classList.add('active');
            }

            // Toggle text between 'Collapse' and 'Expand' based on the current state
            toggleButton.innerHTML = content.classList.contains('active') ? 'Collapse <span class="arrow up"></span>' : 'Expand <span class="arrow down"></span>';

            if (arrow.classList.contains('down')) {
                arrow.innerHTML = 'down';
            } else if (arrow.classList.contains('up')) {
                arrow.innerHTML = 'up';
            }
        });
     });

    
});
